<template>
  <div class="login-page">
    <div class="login-container">
      <img src="@/assets/logo.png" alt="優豆代儲 Logo" class="logo">
      <h1 class="title">歡迎來到優豆代儲後台</h1>
      <p class="subtitle">使用 LINE 帳號，開啟您的征程</p>
      <button @click="goToLineLogin" class="line-login-button">
        <img src="@/assets/line-logo.svg" alt="LINE Logo" class="line-icon">
        使用 LINE 登入
      </button>
      <footer class="footer">
        &copy; {{ new Date().getFullYear() }} 優豆代儲。版權所有。
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoginView',
  methods: {
    goToLineLogin() {
      const baseUrl = process.env.VUE_APP_API_BASE_URL || '';
      window.location.href = `${baseUrl}/auth/line/login`;
    }
  }
}
</script>

<style scoped>
/* You might want to import a more thematic font if you have one, e.g., from Google Fonts */
/* @import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@400;700&family=Roboto:wght@300;400;700&display=swap'); */

.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  /* Dark game style background: very dark, subtle texture/gradient */
  background-color: #121212; /* Base dark color */
  background-image:
      radial-gradient(ellipse at bottom, rgba(80, 20, 80, 0.3) 0%, transparent 60%), /* Subtle purple glow from bottom (was red) */
      linear-gradient(to bottom, rgba(10, 10, 15, 0.9) 0%, rgba(20, 20, 30, 0.95) 70%, #0a0a0a 100%);
  padding: 20px;
  box-sizing: border-box;
  font-family: 'Roboto', 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; /* Fallback fonts */
  /* font-family: 'Cinzel', serif; */ /* Example of a more thematic font */
  overflow: hidden; /* Prevent scrollbars from gradient overflows */
}

.login-container {
  background-color: rgba(25, 25, 35, 0.6); /* Dark, semi-transparent panel */
  padding: 40px 50px;
  border-radius: 10px; /* Slightly sharper edges */
  box-shadow: 0 0 30px rgba(0, 0, 0, 0.7), inset 0 0 10px rgba(120, 80, 180, 0.1); /* Outer dark shadow, subtle inner purple glow */
  text-align: center;
  width: 100%;
  max-width: 450px;
  animation: fadeInRise 0.8s ease-out forwards;
  border: 1px solid rgba(160, 100, 220, 0.6); /* Thematic purple border color */
  position: relative; /* For pseudo-elements if needed */
}

@keyframes fadeInRise {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.logo {
  width: 110px;
  height: auto;
  margin-bottom: 25px;
  filter: drop-shadow(0 0 15px rgba(160, 100, 220, 0.5)); /* Accent color glow - purple */
}

.title {
  font-size: 28px;
  font-weight: 700; /* Bolder for game style */
  /* Keeping fiery / Accent color for title, or can change to a purple-ish tone if preferred */
  color: #ff8c69; /* Fiery orange-red */
  /* color: #d8b8ff; */ /* Alternative light purple for title */
  margin-bottom: 12px;
  text-shadow: 0 0 8px rgba(255, 140, 105, 0.4); /* Text glow, or use purple: rgba(180, 120, 255, 0.4) */
  /* letter-spacing: 1px; */ /* Optional: if using a display font like Cinzel */
}

.subtitle {
  font-size: 16px;
  color: #a0a0b0; /* Muted grey, legible on dark */
  margin-bottom: 40px;
  line-height: 1.6;
}

.line-login-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  /* Green button */
  background: linear-gradient(145deg, #28a745, #218838); /* Green gradient */
  color: #f0f0f0; /* Light text color for contrast */
  font-size: 18px;
  font-weight: 600; /* Bolder button text */
  border: 1px solid #34c759; /* Brighter green border for button */
  padding: 15px 30px;
  border-radius: 6px; /* Sharper edges for game UI */
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  width: 100%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.5), inset 0 1px 1px rgba(255, 255, 255, 0.1);
  text-transform: uppercase; /* Often used in game UIs */
  letter-spacing: 0.5px;
}

.line-login-button:hover {
  background: linear-gradient(145deg, #2ebf4f, #24993f); /* Lighter green on hover */
  border-color: #3fed6e;
  transform: scale(1.02); /* Slight scale up */
  box-shadow: 0 4px 15px rgba(40, 167, 69, 0.3), inset 0 1px 1px rgba(255, 255, 255, 0.15);
}

.line-login-button:active {
  background: linear-gradient(145deg, #218838, #28a745); /* Darker green on active */
  transform: scale(0.98);
  box-shadow: 0 1px 5px rgba(0,0,0,0.6), inset 0 1px 2px rgba(0,0,0,0.2);
}

.line-icon {
  width: 24px;
  height: auto;
  margin-right: 12px;
  /* No filter needed if button is green */
}

.footer {
  margin-top: 30px;
  font-size: 12px;
  color: #707080; /* Darker grey for less emphasis */
}

/* Optional: Add corner elements for more "game UI" feel */
/*
.login-container::before,
.login-container::after {
  content: '';
  position: absolute;
  width: 20px;
  height: 20px;
  border-color: rgba(160, 100, 220, 0.7); // Purple for corners
  border-style: solid;
}
.login-container::before {
  top: -5px;
  left: -5px;
  border-width: 2px 0 0 2px;
}
.login-container::after {
  bottom: -5px;
  right: -5px;
  border-width: 0 2px 2px 0;
}
*/

/* Responsive */
@media (max-width: 480px) {
  .login-container {
    padding: 30px 25px;
    margin: 0 10px;
    border-width: 1px;
  }

  .title {
    font-size: 24px;
  }

  .subtitle {
    font-size: 14px;
  }

  .line-login-button {
    font-size: 16px;
    padding: 12px 20px;
  }

  .logo {
    width: 90px;
  }
}
</style>
